import { render, staticRenderFns } from "./DeleteZoneModal.vue?vue&type=template&id=6ddcacd6&"
import script from "./DeleteZoneModal.vue?vue&type=script&lang=js&"
export * from "./DeleteZoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports